/* eslint-disable no-useless-escape */
import { round } from 'mathjs';
import * as XLSX from 'xlsx';

const Tool = {};

// 邮箱 - 正则判断
// refer: https://c.runoob.com/codedemo/5362/
const testEmail = (value: string) => {
  // eslint-disable-next-line max-len
  const regEmail = /^[a-z]([a-z0-9]*[-_]?[a-z0-9]+)*@([a-z0-9]*[-_]?[a-z0-9]+)+[\.][a-z]{2,3}([\.][a-z]{2})?$/g;
  return regEmail.test(value);
};

// 第二个参数 - 保留几位小数
const newRateABS = (value: any, digit: number = 1) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  return `${round(Math.abs(value) * 100, digit)}%`;
};

// 第二个参数 - 保留几位小数
const newRate = (value: any, digit: number = 1) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  if (value === 0) return '0%';
  return `${round(value * 100, digit)}%`;
};

// 第二个参数 - 保留几位小数
const rawRate = (value: any, digit: number = 1) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  if (value === 0) return '0%';
  return `${round(value, digit)}%`;
};

const locateValue = (value: any) => {
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  return Number(value).toLocaleString();
};

const newValue = (value: any, digit: number = 1) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  return round(Math.abs(value) * 100, digit);
};

const newUrl = (obj:any, showTitleArr: Array<any>, navi?:any) => {
  const url = new URL(window.location.href);
  let title = ''
for (let key in obj) {
  if (obj.hasOwnProperty(key)) { // 确保属性是对象自身的
    if(showTitleArr.includes(key)&&obj[key]){
      title = `${title} | ${obj[key]}`
    }
    url.searchParams.append(key, obj[key]);
    url.searchParams.set(key, obj[key]);
  }
}
document.title = title.replace(' | ', '').replace('_', ' | ');
  
  console.log(url.href);
  // 如果你需要更新浏览器的地址栏，你可以使用history API
  // history.pushState({}, '', url.href);
  if(typeof navi ==='function'){
    navi(`?${url.searchParams.toString()}`, { replace: true });
  }else{
    history.pushState({}, '', url.href);
  }

};



const exportExcelFile = (array:any, merge:any, fileName = 'example.xlsx', sheetName = 'sheet表' ) => {
  const ws = XLSX.utils.aoa_to_sheet(array);
  ws['!merges'] = merge;
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  // console.log(XLSX,wb);
  return XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const getQueryParam = (param:any) => {
  const urlParams: any = new URLSearchParams(window.location.search).get(param);
  let parts = urlParams.split('_');
  let result = parts.length > 1 ? parts : '';
  return result;
}


export default Tool;
export {
  testEmail, newRateABS, newRate, locateValue,
  newValue, rawRate, exportExcelFile,newUrl,getQueryParam
};
